/* eslint-disable max-classes-per-file */
export interface Idata {
    Nummer: number
    Navn: string
    KortNavn?: string
    Type?: string
}

export interface IdataTRfor {
    KortNavn: string
    Navn: string
    Sorteringsorden: number
    Type: string
    Medlemsidenter: number[]
}

export class FilterWorkplace {
    name = ''

    id = 0

    static build(data: Idata): FilterWorkplace {
        const workPlace = new FilterWorkplace()

        workPlace.id = data.Nummer
        workPlace.name = data.Navn

        return workPlace
    }
}

export class FilterWorkGroup {
    name = ''

    id = 0

    static build(data: Idata): FilterWorkGroup {
        const workGroup = new FilterWorkGroup()

        workGroup.id = data.Nummer
        workGroup.name = data.Navn

        return workGroup
    }
}

export class FilterPosition {
    name = ''

    id = 0

    static build(data: Idata): FilterPosition {
        const obj = new FilterPosition()

        obj.id = data.Nummer
        obj.name = data.Navn

        return obj
    }
}

export class FilterUpdateStatus {
    name = ''

    id = ''
}

export class FilterTypeOfRepresentative {
    name = ''

    type = ''

    shortName = ''

    static build(data: Idata): FilterTypeOfRepresentative {
        const obj = new FilterTypeOfRepresentative()

        obj.name = data.Navn
        obj.type = data.Type ? data.Type : ''
        obj.shortName = data.KortNavn ? data.KortNavn : ''

        return obj
    }
}

export class FilterTRFor {
    shortName = ''

    name = ''

    sort = 0

    type = ''

    memberIds: number[]

    displayName = ''

    static build(data: IdataTRfor): FilterTRFor {
        const obj = new FilterTRFor()

        obj.name = data.Navn
        obj.displayName = `${data.Navn}(${data.KortNavn})`
        obj.shortName = data.KortNavn
        obj.sort = data.Sorteringsorden
        obj.type = data.Type
        obj.memberIds = data.Medlemsidenter

        return obj
    }
}

export interface IFilter {
    workplaces: FilterWorkplace[]
    groups: FilterWorkGroup[]
    positions: FilterPosition[]
    typeOfRepresentative: FilterTypeOfRepresentative[]
    representing: FilterTRFor[]
    updateStatus: FilterUpdateStatus[]
}

export const initialFilter: IFilter = {
    workplaces: [],
    groups: [],
    typeOfRepresentative: [],
    representing: [],
    positions: [],
    updateStatus: [],
}

export const initialSelectedFilters: IFilter = {
    workplaces: [],
    groups: [],
    typeOfRepresentative: [],
    representing: [],
    positions: [],
    updateStatus: [],
}
